import { ooFetchWithResponse } from './ooFetchWithResponse';

let consumeApi = {
    eatItem: async (params) => {
        let url = 'consume/v1/item';
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
    eatRecipe: async (params) => {
        let url = 'consume/v1/recipe';
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
    editConsumedTime: async (id, newTime) => {
        let url = 'consume/v1/modify/' + id;
        let body = JSON.stringify(newTime);
        let response = await ooFetchWithResponse(url, { method: "PUT", body: body });
        return response;
    },
    getConsumptionInfo: async (dateEaten ) => {
        let url = 'consume/v1/eaten?date=' + dateEaten;
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    recommendBreakfast: async () => {
        let url = 'recommend/v1/breakfast';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    recommendDinner: async () => {
        let url = 'recommend/v1/dinner';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    recommendLunch: async () => {
        let url = 'recommend/v1/lunch';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    recommendSnack: async () => {
        let url = 'recommend/v1/snack';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    removeConsumedItem: async (id) => {
        let url = 'consume/v1/removeItem/' + id;
        let response = await ooFetchWithResponse(url, { method: "POST" });
        return response;
    },
    trackNutrient: async(start, end, nutrient) => {
        let url = 'consume/v1/nutrient?dateStart=' + start + "&dateStop=" + end + "&nutrient=" + nutrient;
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    }
}

export { consumeApi };